
			document.addEventListener('DOMContentLoaded', () => {
			  import('/src/main.ts')
			})
		  